import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PromoComponent } from '@finder/shared/components/promo/promo.component';

@Component({
    selector: 'finder-promo-group',
    templateUrl: './promo-group.component.html',
    styleUrls: ['./promo-group.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        PromoComponent,
    ]
})
export class PromoGroupComponent {

    @Input() promos: any[];

    constructor() { }

}
